export default {
  data: {
    newStudentsOnly: false,
    name: null,
    description: null,
    courses: [],
    programs: [],
    selectedCoursesIds: [],
    selectedProgramsIds: [],
    couponCampaignId: [],
  },

  methods: {
    bindData(data) {
      this.courses = data.courses;
      this.programs = data.programs;
      this.couponCampaignId = data.coupon_campaign_id;
      this.name = data.name;
      this.description = data.description;

      data.coupon_products.forEach(couponProduct => {
        if (couponProduct.productable_type === 'Program') {
          this.selectedProgramsIds.push(couponProduct.productable_id);
        } else {
          this.selectedCoursesIds.push(couponProduct.productable_id);
        }
      })
    },

    useRandomCodes() {
      this.randomCodes = true;
      this.singleCode = false;
    },

    useSingleCode() {
      this.randomCodes = false;
      this.singleCode = true;
    },

    initUI() {
      if ($('#js-coupon-campaign-new-student-only').val()) {
        this.newStudentsOnly = true;
      }
      setTimeout(() => {
        Kadenze.UIUtil.initExpandableText();
      }, 100);
    },

    isValid(formData) {
      return !_.isEmpty(formData.name);
    },

    submit() {
      var selectedCourses = [];
      var selectedPrograms = [];

      this.selectedCoursesIds.forEach(id => {
        selectedCourses.push(this.getProductById(id, this.courses))
      })

      this.selectedProgramsIds.forEach(id => {
        selectedPrograms.push(this.getProductById(id, this.programs))
      })

      const selectedProducts = [selectedCourses, selectedPrograms].flat(2)

      const formData = this.couponFormData();

      if (this.isValid(formData) ) {
        const data = {
          coupon_campaign: formData,
          selected_products: selectedProducts,
        };

        const id = this.couponCampaignId;

        const method = id ? 'PUT' : 'POST'

        const url = id ?
          Kadenze.Routes.admin_coupon_campaign_path(id) :
          Kadenze.Routes.admin_coupon_campaigns_path()

        const req = new Kadenze.AjaxRequest({
          type: method,
          data: data,
          url: url,
          loadingIndicator: { container: $('#js-coupon-campaign-form') }
        });

        req.done(function(data) {
          new Kadenze.Notice.success();

          Kadenze.Request.pjax({
            url: data.redirect_to,
            container: $('#main-pjax-container')
          });
        });
      } else {
        new Kadenze.Notice.error({ message: 'Name cannot be blank' });
      }
    },
    couponFormData() {
      const data = {};

      $('#js-coupon-campaign-form').parents('form').serializeArray().map(
        function (x) { data[x.name] = x.value; }
      );

      return {
        name: this.name,
        description: this.description,
        new_students_only: data['coupon_campaign[new_students_only]'],
        product_access_length_days: data[
          'coupon_campaign[product_access_length_days]'
        ],
      };
    },

    getProductById(id, products){
      return _.select(products, function (product){
        return product.id === parseInt(id)
      });
    }
  },

  mounted() {}
};
